class SpecimenAdditionalInfoService {
  constructor({ axios }) {
    this.axios = axios;
  }

  async getList({ query = '', dates = [] } = {}) {
    const result = await this.axios.get('/api/biobank/specimen-additional-infos', {
      params: {
        query,
        ...(Object.keys(dates).length > 0 && dates),
      },
    });
    const { data } = result;
    return data;
  }

  async getOne({ id }) {
    const { data } = await this.axios.get(`/api/biobank/specimen-additional-infos/${id}`);
    return data;
  }

  async create({ specimenAdditionalInfo }) {
    const { data } = await this.axios.post('/api/biobank/specimen-additional-infos', specimenAdditionalInfo);
    return data;
  }

  async update({ specimenAdditionalInfo }) {
    const { data } = await this.axios.put('/api/biobank/specimen-additional-infos', specimenAdditionalInfo);
    return data;
  }

  async archive({ specimenAdditionalInfo }) {
    const { _id: id } = specimenAdditionalInfo;
    const { data } = await this.axios.delete(`/api/biobank/specimen-additional-infos/archive/${id}`, { data: specimenAdditionalInfo });
    return data;
  }
}

export default SpecimenAdditionalInfoService;
